// extracted by mini-css-extract-plugin
module.exports = {"root":"validation_indicator__root__it8X3 padding__padding_left_small__XKm7u padding__padding_right_small__lpfNe flex__align_self_center__VsURJ"};